import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ErrorComponent } from './error/error.component';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './guard/auth.guard';
import { LocalComponent } from './local/local.component';
import { BigHomeComponent } from './big-home/big-home.component';
import { BigLocalComponent } from './big-local/big-local.component';


const routes: Routes = [
  { path: '', redirectTo: '/auth', pathMatch: 'full' },
  { path: 'auth', component: AuthComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'big-home', component: BigHomeComponent, canActivate: [AuthGuard] },
  { path: 'local', component: LocalComponent, canActivate: [AuthGuard] },
   { path: 'big-local', component: BigLocalComponent, canActivate: [AuthGuard] },
  { path: 'error', component: ErrorComponent },
  { path: 'error/:errorCode', component: ErrorComponent },
  { path: '**', redirectTo: 'auth' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableViewTransitions: true})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
